module.exports = __webpack_public_path__ + "img/w_mockup.fd7a2a88.png";